import apiService from '@/services/apiService'

// Puente manual hacia pedidos web del ecommerce (RF-7 de
// SPEC_ECOMMERCE_CUENTAS_v0.1.md, paginado en la Ampliación 2026-07-30) —
// deliberadamente separado del CRUD de `pedidos` (ordersService), no toca
// esa lógica.
export default {
  async listPendientes({ page = 1, limit = 10, q = '', estado = 'pendientes', orden = 'antiguos' } = {}) {
    const params = { page, limit, estado, orden }
    if (q) params.q = q
    const { data } = await apiService.get('/api/maintenance/ecommerce/pedidos-online', params)
    return {
      pedidos: Array.isArray(data?.pedidos) ? data.pedidos : [],
      paginacion: data?.paginacion || { total: 0, page: 1, limit, totalPages: 1, hasNextPage: false, hasPrevPage: false },
    }
  },
  async countPendientes() {
    const { data } = await apiService.get('/api/maintenance/ecommerce/pedidos-online/pendientes/count')
    return Number(data?.total) || 0
  },
  async importar(pedidoOnlineId, sucursalId) {
    const { data } = await apiService.post(`/api/maintenance/ecommerce/pedidos-online/${pedidoOnlineId}/importar`, {
      sucursal_id: sucursalId,
    })
    return data
  },
  // Descarta un e-pedido que no se va a atender. No borra el registro: lo saca
  // de pendientes conservando qué pidió el cliente y por qué se descartó.
  async descartar(pedidoOnlineId, motivo) {
    const { data } = await apiService.post(`/api/maintenance/ecommerce/pedidos-online/${pedidoOnlineId}/descartar`, {
      motivo,
    })
    return data
  },
  // Revierte un descarte (RF-7): el pedido vuelve a la cola de pendientes.
  // El motivo y la fecha del descarte anterior se conservan en el backend.
  async revertirDescarte(pedidoOnlineId) {
    const { data } = await apiService.post(`/api/maintenance/ecommerce/pedidos-online/${pedidoOnlineId}/revertir-descarte`)
    return data
  },
}
